<div class="notifications-container">
  <div *ngFor="let notification of notifications" class="notification" [ngClass]="notificationClass(notification)">
    <svg-icon [svgStyle]="{ 'width.rem': '2' }" class="icon" [src]="'../../../assets/img/icons/' + (notification.icon ? notification.icon : 'alert.svg')"></svg-icon>
    <span class="message">{{ notification.message }}</span>
    <span class="close" (click)="close(notification)">&times;</span>
  </div>
</div>